import { setTheme, useThemeChoice, type ThemeChoice } from "./theme";

// Bascule rapide clair / sombre / système. Les thèmes de marque (rose Astuce,
// rouge Transdev) se choisissent dans Paramètres — depuis l'un d'eux, la bascule
// revient au clair.
const NEXT: Partial<Record<ThemeChoice, ThemeChoice>> = { system: "light", light: "dark", dark: "system" };
const LABEL: Record<ThemeChoice, string> = {
  system: "Système",
  light: "Clair",
  dark: "Sombre",
  "rose-astuce": "Rose Astuce",
  "rouge-transdev": "Rouge Transdev",
};
const ICON: Partial<Record<ThemeChoice, string>> = { system: "◐", light: "○", dark: "●" };

/** Bascule de thème clair / sombre / système (F4.4). */
export function ThemeToggle() {
  const choice = useThemeChoice();
  const next = NEXT[choice] ?? "light";
  return (
    <button
      type="button"
      className="button is-small"
      onClick={() => setTheme(next)}
      title={`Thème : ${LABEL[choice]} — cliquer pour ${LABEL[next]}`}
      aria-label={`Thème ${LABEL[choice]}, basculer vers ${LABEL[next]}`}
      style={{ background: "transparent", color: "#fff", borderColor: "hsla(0,0%,100%,.25)" }}
    >
      <span aria-hidden style={{ marginRight: 6 }}>
        {ICON[choice] ?? "◑"}
      </span>
      <span className="ovl" style={{ color: "#fff" }}>
        {LABEL[choice]}
      </span>
    </button>
  );
}
